<template>
  <div class="row">
    <div class="col-12">
    <div>
      <label>{{$t('message.schedules.example')}}</label>
      <div class="row">
        <div class="slot-preview-item col-3" v-for="preview in previews" :key="preview.startTime">
          <div class="slot-preview-time-box">
            {{preview.time}}
          </div>
          <div class="slot-preview-persons">
            <i class="fa fa-male" aria-hidden="true" v-for="bn in previewIcons" :key="bn"></i>
          </div>
          <div class="slot-preview-desc">
            <p>{{$t('message.schedules.booking_number')}} {{preview.booking}} {{$t('message.schedules.booking_unit')}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="form-divider"></div>
  </div>
</div>
</template>

<script>

import moment from 'moment'

export default {
  props: {
    start_time: {
      type: String,
      default: '9:00'
    },
    time_slots: {
      type: Number,
      default: 30
    },
    booking_per_slot: {
      type: Number,
      default: 4
    }
  },
  computed: {
    previews () {
      var time = moment(this.start_time, 'HH:mm')
      return [...Array(4).keys()].map(n => {
        let timeString = time.format('HH:mm')
        time = time.add(this.time_slots, 'minutes')
        return {time: timeString, booking: this.booking_per_slot}
      })
    },
    previewIcons () {
      return [...Array(this.booking_per_slot).keys()]
    }
  }
}
</script>

<style lang="scss">

.slot-preview-time-box {
  width: 100%;
  padding: 0.3rem;
  text-align: center;
  color: #FFF;
  background: #5cb85c;
  border-color: #4cae4c;
  border-radius: 4px;
}

.slot-preview-persons {
  text-align: center;
  margin: 0.2rem;
}

.slot-preview-desc {
  width: 100%;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// WorkingSlotPreview.vue?3e74c9c4